import { getApprovalGroupsUserActionable } from 'AppSrc/core/components/view-crq-screen/utility-functions/get-view-crq-powers';


const getDisplayOptionsForApprovers = (formData) => {
  if (!formData) {
    console.error(`Unable to make to make display options with formData: ${formData}`);
    return [];
  }

  const {
    approvalHistory,
  } = formData;

  if (!approvalHistory) {
    console.error(`Unable to make to make display options with approvalHistory: ${approvalHistory}`);
    return [];
  }

  const approvalGroupsUserActionable = getApprovalGroupsUserActionable(approvalHistory);

  return approvalGroupsUserActionable.map((item) => {

    const groupName = item.group;
    const userId = item.userId;
    const text = groupName ? groupName : userId;

    return ({
      text: text ? text : 'Unknown group',
      value: item,
    });
  });
};


export {
  getDisplayOptionsForApprovers,
};
